import { motion } from "motion/react";
import { Link } from "@tanstack/react-router";
import { GraduationCap, Trophy, Home, ArrowRight } from "lucide-react";

const lifeCards = [
  {
    icon: GraduationCap,
    title: "Academics",
    description:
      "Rigorous academic programs with modern ICT facilities and a well-stocked library to support learning excellence.",
    image:
      "/academics.png",
    link: "/facilities#academics",
    color: "bg-blue-600",
  },
  {
    icon: Trophy,
    title: "Extra Curricular",
    description:
      "Diverse sporting activities and clubs that develop teamwork, leadership, and physical fitness.",
    image:
      "/extra-curricular-1.png",
    link: "/facilities#extra-curricular",
    color: "bg-red-600",
  },
  {
    icon: Home,
    title: "Boarding",
    description:
      "Comfortable accommodation with excellent catering services in a home-away-from-home environment.",
    image:
      "/boarding-1.png",
    link: "/facilities#boarding",
    color: "bg-blue-800",
  },
];

export function LifeAtHilltop() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-red-100 text-red-700 rounded-full text-sm font-medium mb-4">
            Experience Excellence
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Life at Hilltop
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Discover the vibrant community and enriching experiences that await
            your child.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {lifeCards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >
              <Link to={card.link} className="group block h-full">
                <div className="relative overflow-hidden rounded-3xl h-full bg-white shadow-sm hover:shadow-2xl transition-all duration-500">
                  {/* Image */}
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />

                    {/* Icon Badge */}
                    <div
                      className={`absolute top-4 right-4 w-12 h-12 ${card.color} rounded-xl flex items-center justify-center shadow-lg`}
                    >
                      <card.icon className="w-6 h-6 text-white" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-red-600 transition-colors">
                      {card.title}
                    </h3>
                    <p className="text-slate-600 mb-4 leading-relaxed">
                      {card.description}
                    </p>
                    <div className="flex items-center text-red-600 font-medium">
                      <span>Learn More</span>
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-2 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
